import { HUB_ENDPOINTS, PROD_HUB_BASE_URL } from "@memorang/constants/urls";
import * as Crypto from "expo-crypto";

export const getTtsAudioData = async (
	explanation: string,
	appName: string,
	cacheKey: string,
	authToken: string | null,
	shouldStream?: boolean,
) => {
	const params = new URLSearchParams({
		text: explanation,
		shouldStream: String(!!shouldStream),
		appName,
		cacheKey,
	});

	const response = await fetch(
		`${PROD_HUB_BASE_URL}${HUB_ENDPOINTS.TTS}?${params}`,
		{
			headers: authToken ? { Authorization: authToken } : undefined,
		},
	);
	const contentType = response.headers.get("content-type");

	if (contentType?.includes("application/json")) {
		const data = await response.json();
		return data.audio;
	}

	if (shouldStream) {
		return response.body;
	}
	const data = await response.json();
	return data.audio;
};

export const getTTSCacheKey = async (
	org: string,
	tenantId: string,
	appId: string,
	transcript: string,
) => {
	const transcriptHash = (
		await Crypto.digestStringAsync(
			Crypto.CryptoDigestAlgorithm.SHA256,
			transcript,
		)
	).slice(0, 8);
	return `${org}:${tenantId}:${appId}:TTS:${transcriptHash}`;
};
